import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Hero() {
  return <section data-section-id="193107" id="services-hero" className="relative w-full min-h-[80vh] flex items-center justify-center bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598014/img/hero_background_wellness.png)] bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-[hsl(240,10%,2%)]/40 to-[hsl(240,10%,2%)]/90" />

      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center animate-in fade-in slide-in-from-bottom-5 duration-1000 fill-mode-forwards">
        <h1 className="text-4xl md:text-6xl lg:text-[72px] font-default font-extrabold text-white mb-6 max-w-4xl leading-tight tracking-tight">
          Private Airport Transfers in the Bay Area — Without Surprises
        </h1>
        
        <p className="text-lg md:text-xl text-[hsl(0,0%,70%)] font-sans font-medium mb-10 max-w-3xl leading-relaxed">
          On-time, discreet, professional drivers. 100% ON-TIME | LICENSED & INSURED | SFO • OAK • SJC
        </p>
        
        <Link to="/ReachUsPage">
          <Button size="lg" className="text-base px-8 h-12 bg-primary text-primary-foreground hover:opacity-90 transition-opacity font-sans rounded-sm shadow-lg">
            Reserve Your Ride
          </Button>
        </Link>
      </div>
    </section>;
}